import { generateQueryKey } from 'query';

// TODO: create query key as const - 82948
export const getReleaseNotesQueryKey = (params: { limit: number }) => generateQueryKey(['release-notes', params]);
